module.exports = __webpack_public_path__ + "img/a1.0e57e45b.png";